export const focusOnElement = elem_id => {
	const elem = document.getElementById(elem_id);
	if (elem) {
		elem.focus();
		return true;
	}
	return false;
};
